// extracted by mini-css-extract-plugin
export default {"cta":"yG-z","disabled":"zG-z"};